import { Redirect } from 'expo-router'

/**
 * Legacy redirect — older deep-links to /legal/terms still resolve to
 * the canonical /legal/terms-of-service slug used by the marketing site.
 */
export default function TermsRedirect() {
  return <Redirect href={'/legal/terms-of-service' as never} />
}
